import { useEffect, useState } from "react"
import Modal from 'react-bootstrap/Modal'
import Button from '@mui/material/Button'
//import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

export function ListItem( props )
{
    const list = props.list 
    const setList = props.setList 
    const index = props.index 

    const [ text, setText ] = useState( list[index] )

    useEffect( () => {
        setText( list[index] )
    },[list,index]) 

    const update = () => {
        list[index] = text
    }

    const remove = () => {
        let pp = structuredClone(list)
        pp.splice(index,1)
        setList(pp)
    }

    return (
        <div style={{ marginBottom:'5px'}}>
            <InputGroup size="sm">
                <Form.Control value={text} onChange={ e => setText(e.target.value)}/>
                <Button style={{textTransform:'none'}} onClick={update}>Update</Button>
                <Button style={{textTransform:'none'}} onClick={remove}>Remove</Button>
            </InputGroup>
        </div>
    )
}

export default function DataListModal( props )
{
    const modalTitle = props.modalTitle
    const showModal = props.showModal 
    const setShowModal = props.setShowModal 

    const list = props.list 
    const setList = props.setList 

    const [ text, setText ] = useState("")
    const [ file, setFile ] = useState(null)
    const [ colName, setColName ] = useState("")

    useEffect( () => {
        if( showModal )
        {
            setText("")
        }

    },[showModal])

    const addToList = ( text ) => {
        if( text == "" )
        {
            return 
        }

        let pp = structuredClone(list)
        pp.push( text )

        setList(pp)
        setText("")
    }

    return (
        <Modal show={showModal} onHide={e => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom:'5px'}}>
                    <InputGroup size="sm">
                        <Form.Control value={text} onChange={ e => setText(e.target.value)} 
                                      placeHolder="Single entry"
                        />
                        <Button onClick={e => addToList(text)} style={{ textTransform:'none' }}>Add</Button>
                    </InputGroup>
                </div> 
                <div style={{ width:'100%', height:'250px', overflowY:'scroll', padding:'10px'}}>
                    { list &&
                    <>
                    { list.map( (pp,idx) => 
                    <ListItem key={idx} list={list} setList={setList} index={idx} 
                    />
                    )}
                    </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={e => setShowModal(false)} 
                        size="sm" style={{ marginRight:'5px', textTransform:'none' }}
                    >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

